const OptionLIst =
{
  addBtn: false,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  tip: false,
  searchShow: false,
  searchMenuSpan: 2,
  border: true,
  index: true,
  indexLabel: '序号',
  indexWidth: 80,
  selection: false,
  column: [{
    label: '投屏时间',
    prop: 'receiverCastServerTimestamp',
    width: 200,
    slot: true,
    align: 'left',
  }, {
    label: '手机号（发端）',
    prop: 'clientMobilePhone',
    width: 200,
  }, {
    label: '用户uuid（发端）',
    prop: 'clientLeboUuid',
    width: 180,
  }, {
    label: '发端uid(cu)',
    prop: 'clientSdkUserId',
    width: 180,
  }, {
    label: '发端渠道appid+渠道名',
    prop: 'clientSdkChannelName',
    width: 180,
  }, {
    label: '发端平台类型',
    prop: 'clientPlatformType',
    width: 200,
  }, {
    label: '发端设备类型',
    prop: 'clientBusinessType',
    width: 200,
  }, {
    label: '发端设备品牌',
    prop: 'clientDeviceBrand',
    width: 200,
  }, {
    label: '发端设备型号',
    prop: 'clientDeviceModel',
    width: 200,
  }, {
    label: '发端省份城市',
    prop: 'clientIpCode',
    width: 200,
  }, {
    label: '发端ip',
    prop: 'clientIp',
    width: 200,


  }, {
    label: '发端mac地址',
    prop: 'createTime',

  },
  {
    label: '收端手机号',
    prop: 'receiverMobilePhone',
    width: 200,

  }, {
    label: '收端uuid',
    prop: 'receiverLeboUuid',
    width: 200,

  }, {
    label: '收端uid',
    prop: 'receiverSdkUserId',
    width: 200,
  }, {
    label: '收端渠道appid+渠道名',
    prop: 'receiverSdkChannelName',
    width: 200,
  }, {
    label: '收端平台类型',
    prop: 'receiverPlatformType',
    width: 200,
  }, {
    label: '收端省份城市',
    prop: 'receiverIpCode',

    width: 200,

  }, {
    label: '收端ip',
    prop: 'receiverIp',

    width: 200,
  }, {
    label: '收端mac地址',
    prop: 'receiverDeviceMac',
    width: 200,
  },]
}

export default OptionLIst